import { InfiniteScroll } from "@commonlibs";
import clsx from "clsx";
import List from "../List/List";
import { InfiniteListProps } from "./InfiniteList.types";
import splitInfiniteScrollProps from "../../util/InfiniteDataList/utils/splitInfiniteScrollProps/splitInfiniteScrollProps";

function InfiniteList<E>(props: InfiniteListProps<E>) {
    const {
        infiniteScrollProps: { children, ...rest },
        componentProps: { className, ...listProps },
    } = splitInfiniteScrollProps<E, InfiniteListProps<E>>(props);

    return (
        <InfiniteScroll {...rest}>
            <List className={clsx("infinite-list", className)} {...listProps}>
                {children}
            </List>
        </InfiniteScroll>
    );
}

export default InfiniteList;
